import { portalAction, PortalThunk } from '../'
import { FinishBiometricRegistrationRequest, StartBiometricRegistrationData } from '../../model'

export const startBiometricRegistration: PortalThunk<void, StartBiometricRegistrationData> = portalAction(
  'consumers/fido2/registration/start',
  async (_, thunk) => {
    return await thunk.extra.portalApi().post('/portal/consumers/fido2/register', {})
  }
)

export const finishBiometricRegistration: PortalThunk<FinishBiometricRegistrationRequest, void> = portalAction(
  'consumers/fido2/registration/finish',
  async (request, thunk) => {
    return await thunk.extra.portalApi().post('/portal/consumers/fido2/register/finish', request)
  }
)
